import { useTranslation } from 'next-i18next/pages';
import React, { useRef } from 'react';

import { getButtonClassName } from '../../button/Button.component';
import ContainerSection from '../../container-section';

const COLLAPSED_LENGTH = 8;

interface LandingPageJobTitlesProps {
  jobTitles: string[];
  headline?: React.ReactElement;
  showManyMoreLabel?: boolean;
}

const LandingPageJobTitles: React.FC<LandingPageJobTitlesProps> = ({ jobTitles, headline, showManyMoreLabel = true }) => {
  const { t } = useTranslation('landingPage', { keyPrefix: 'jobSearch' });
  const scrollRef = useRef<HTMLDivElement>(null);

  const [isExpanded, setIsExpanded] = React.useState(false);
  const handleExpansionClick = React.useCallback(() => {
    setIsExpanded(value => !value);
  }, []);

  return (
    <div className='bg-primary-100'>
      <ContainerSection>
        <div className='my-32 flex flex-col items-center hyphens-auto'>
          {headline ?? null}
          <div className='mt-16 flex w-full flex-col md:mt-4' ref={scrollRef}>
            <div className='flex flex-col'>
              <div className='grid-span-2 grid auto-rows-fr gap-2 md:grid-cols-4 md:gap-4'>
                {jobTitles.slice(0, isExpanded ? undefined : COLLAPSED_LENGTH).map(jobTitle => (
                  <div
                    key={jobTitle}
                    className='flex grow items-center justify-center rounded-2xl border border-gray-200 bg-white p-2 text-center shadow-2xl outline-hidden transition-colors md:p-5 md:shadow-none'>
                    {t(`titles.${jobTitle}`)}
                  </div>
                ))}
              </div>
              {isExpanded && showManyMoreLabel && <p className='text-default mt-6 text-center text-xl md:text-2xl'>{t('manyMore')}</p>}
              <div className='mt-16 flex justify-center'>
                {jobTitles.length > COLLAPSED_LENGTH && (
                  <button className={getButtonClassName('primary', 'w-48')} onClick={handleExpansionClick}>
                    {t(isExpanded ? 'less' : 'more')}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </ContainerSection>
    </div>
  );
};

export default LandingPageJobTitles;
